import React from 'react';

/** Labeled card section for profile edit / view grouping. */
export default function ProfileSection({ title, hint, children, testId }) {
  return (
    <section
      className="rounded-xl border border-zinc-200 bg-white p-4 space-y-4"
      data-testid={testId}
    >
      <header>
        <h3 className="text-sm font-semibold text-zinc-900">{title}</h3>
        {hint ? <p className="text-[11px] text-zinc-500 mt-0.5">{hint}</p> : null}
      </header>
      {children}
    </section>
  );
}
